import classNames from 'classnames';
import { useLocaleStore } from '@/i18n';
import './style.less';
import IconFont from '@meitu/xdesign-icon-font';

type Props = React.ComponentProps<'div'> & {
    title: string;
    onFindMore?: () => void;
};

const BlockContainer: React.FC<Props> = ({ children, title, onFindMore, className, style = {} }) => {
    const { $t } = useLocaleStore();

    return (
        <div className={classNames('block-container', className)} style={style}>
            <div className="block-container__header">
                <div className="block-container__title">{title}</div>
                {onFindMore ? (
                    <div className="block-container__more" onClick={onFindMore}>
                        <span>{$t((v) => v.collapse.shortcutCollapse.picture.more)}</span>
                        <IconFont
                            name="ChevronRightBlack"
                            fontSize={10}
                            color="var(--content-system-secondary, #616366)"
                            style={{ marginLeft: 4 }}
                        />
                    </div>
                ) : null}
            </div>

            <div className="block-container__content">{children}</div>
        </div>
    );
};

export default BlockContainer;
